import { render, staticRenderFns } from "./OurRangeNewVehicles.vue?vue&type=template&id=60de38c8"
import script from "./OurRangeNewVehicles.vue?vue&type=script&lang=js"
export * from "./OurRangeNewVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports